export const GET_VIEW_CONSULTATION = "GET_VIEW_CONSULTATION"
export const GET_VIEW_CONSULTATION_FAIL = "GET_VIEW_CONSULTATION_FAIL"
export const GET_VIEW_CONSULTATION_SUCCESS = "GET_VIEW_CONSULTATION_SUCCESS"
export const GET_VIEW_CONSULTATION_RESET = "GET_VIEW_CONSULTATION_RESET"

export const getViewConsultation = (params) => {
    return { type: GET_VIEW_CONSULTATION, params }
}

export const getViewConsultationSuccess = (response) => {
    return { type: GET_VIEW_CONSULTATION_SUCCESS, response }
}

export const getViewConsultationFail = (response) => {
    return { type: GET_VIEW_CONSULTATION_FAIL, response }
}

export const getViewConsultationReset = () => {
    return { type: GET_VIEW_CONSULTATION_RESET }
}